<p-toast></p-toast>
<div class="grid p-fluid">
    <div class="col-12">
        <div class="card">
            <!-- <p-toolbar>
                <div class="p-toolbar-group-left w-full">
                    <div class="field mb-0 col-12">
                        <div class="col-6 flex align-content-left justify-content-start align-items-center">
                            <h3 class="m-0">Location: {{ currentLocation }}</h3>
                        </div>
                    </div>
                </div>
            </p-toolbar> -->
            <p-messages key="tip-msg"></p-messages>
            <div *ngIf="!isProfilesLoading && !loadingSettings; else spinner">
                <div *ngIf="!isProfileContactsLoading else profileDeleteCount">
                    <p-table #contactsTable [value]="allProfileContacts"
                        [globalFilterFields]="['monthly_profile_details.lid', 'monthly_profile_details.suite', 'monthly_profile_details.account', 'contactName']"
                        [resizableColumns]="true" responsiveLayout="scroll" [paginator]="true" [rows]="150"
                        [totalRecords]="allProfileContactsCount" [loading]="isProfileContactsLoading"
                        [(selection)]="selectedContacts">
                        <ng-template pTemplate="caption">
                            <div class="flex align-items-center justify-content-between">
                                <div class="flex gap-2">
                                    <p-button severity="danger" label="Delete Selected ParkPro contacts" icon="pi pi-trash"
                                        outlined (onClick)="deleteSelectedContacts()"
                                        [disabled]="!selectedContacts || !selectedContacts.length"
                                        [loading]="isProfileContactsLoading" />
                                    <p-button severity="danger" label="Delete All ParkPro Contacts" icon="pi pi-trash" outlined
                                        (onClick)="deleteSelectedContacts('all')"
                                        [disabled]="selectedContacts?.length || !allProfileContacts.length"
                                        [loading]="isProfileContactsLoading" />
                                </div>
                                <div class="flex gap-2" [class.col-3]="!locationSettings.wpsActive" [class.col-6]="locationSettings.wpsActive">
                                    <span class="col-6 relative" *ngIf="locationSettings.wpsActive">
                                        <div class="flex align-items-center gap-1">
                                            <p-checkbox [(ngModel)]="disableSureparkContact" [binary]="true"></p-checkbox>
                                            <label>Mark SUREPARK Contact as Inactive</label>
                                        </div>
                                        <small class="text-gray-600 left-0"
                                               style="top: 100%; white-space: normal; width: 100%; margin-top: 0.25rem">
                                            When checked ParkPro contacts that are expired and deleted will have their
                                            corresponding SUREPARK account marked as inactive. SUREPARK accounts are never deleted.
                                        </small>
                                    </span>
                                    <span class="p-input-icon-left" style="max-height: 50px;">
                                        <i class="pi pi-search"></i>
                                        <input pInputText type="text"
                                            (input)="contactsTable.filterGlobal($any($event.target).value, 'contains')"
                                            placeholder="Search..." />
                                    </span>
                                </div>
                            </div>
                        </ng-template>
                        <ng-template pTemplate="header">
                            <tr>
                                <th style="width: 4rem"><p-tableHeaderCheckbox /></th>
                                <th pResizableColumn pSortableColumn="monthly_profile_details.account">
                                    Account
                                    <p-sortIcon field="monthly_profile_details.account"></p-sortIcon>
                                </th>
                                <th>Contact Name</th>
                                <th>Keycard</th>
                                <th>Rate</th>
                                <th>Effective Date</th>
                                <th>Termination Date</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-contact>
                            <tr>
                                <td [class.border-none]="contact.monthly_profile_details?.is_billing_contact"
                                    [class.pb-0]="contact.monthly_profile_details?.is_billing_contact">
                                    <p-tableCheckbox [value]="contact"
                                        [disabled]="contact.monthly_profile_details?.is_billing_contact" />
                                </td>
                                <td class="mpi-text-truncate"
                                    [class.border-none]="contact.monthly_profile_details?.is_billing_contact"
                                    [class.pb-0]="contact.monthly_profile_details?.is_billing_contact">{{
                                    contact.monthly_profile_details.suite }} - {{
                                    contact.monthly_profile_details.account }}</td>
                                <td class="mpi-text-truncate"
                                    [class.border-none]="contact.monthly_profile_details?.is_billing_contact"
                                    [class.pb-0]="contact.monthly_profile_details?.is_billing_contact">{{
                                    contact.contactName }}</td>
                                <td class="mpi-text-truncate"
                                    [class.border-none]="contact.monthly_profile_details?.is_billing_contact"
                                    [class.pb-0]="contact.monthly_profile_details?.is_billing_contact">{{
                                    contact.keycards }}</td>
                                <td class="mpi-text-truncate"
                                    [class.border-none]="contact.monthly_profile_details?.is_billing_contact"
                                    [class.pb-0]="contact.monthly_profile_details?.is_billing_contact">
                                    {{ contact.monthly_profile_details?.contact_rate_description || contact.rate }}</td>
                                <td class="mpi-text-truncate"
                                    [class.border-none]="contact.monthly_profile_details?.is_billing_contact"
                                    [class.pb-0]="contact.monthly_profile_details?.is_billing_contact">{{
                                    contact.effectiveDates }}</td>
                                <td class="mpi-text-truncate"
                                    [class.border-none]="contact.monthly_profile_details?.is_billing_contact"
                                    [class.pb-0]="contact.monthly_profile_details?.is_billing_contact">{{
                                    contact.terminationDates }}</td>
                            </tr>
                            <tr *ngIf="contact.monthly_profile_details?.is_billing_contact">
                                <td colspan="7" class="pt-0">
                                    <small class="ui-messages-error block ml-0">
                                        Cannot delete billing contacts. Please assign an active contact as the billing
                                        contact or mark the account as inactive
                                    </small>
                                </td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                            <tr>
                                <td colspan="8" class="text-center"><b>No Data Found.</b></td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
                <ng-template #profileDeleteCount>
                    <div class="col-12 md:col-8 lg:col-6 md:lg:col-offset-2 lg:col-offset-3">
                        <div class="flex justify-content-between flex-wrap">
                            <h1>Deleting Profile Contacts</h1>
                            <!-- <p-button class="my-auto" styleClass="ui-messages-error" severity="danger" label="Cancel process" icon="pi pi-times" [link]="true" (onClick)="cancelProfileContactProcess()"/> -->
                        </div>

                        <p-progressBar [value]="profileContactDeletedPercent">
                            <ng-template pTemplate="content" let-value>
                                <span>{{value}}%</span>
                            </ng-template>
                        </p-progressBar>
                        <div class="flex justify-content-between flex-wrap">
                            <h3>{{ selectedContacts?.length || 0 }} / {{ totalProfileContactDeleted }}</h3>
                            <h3 class="ui-messages-error my-auto">Failed {{ profileContactDeleteFailed }}</h3>
                        </div>
                        <p-messages key="delete-profile-contact-error"></p-messages>
                    </div>
                </ng-template>
            </div>
            <ng-template #spinner>
                <div class="col-12" *ngIf="loadingSettings">
                    <p-progressSpinner></p-progressSpinner>
                </div>

                <div class="col-12 md:col-8 lg:col-6 md:lg:col-offset-2 lg:col-offset-3" *ngIf="isProfilesLoading">
                    <div class="flex justify-content-between flex-wrap">
                        <h1>Loading Profiles</h1>
                        <p-button class="my-auto" styleClass="ui-messages-error" severity="danger"
                            label="Cancel process" icon="pi pi-times" [link]="true"
                            (onClick)="cancelProfileContactProcess()" />
                    </div>

                    <p-progressBar [value]="profileContactFetchedPercent">
                        <ng-template pTemplate="content" let-value>
                            <span>{{value}}%</span>
                        </ng-template>
                    </p-progressBar>
                    <div class="flex justify-content-between flex-wrap">
                        <h3>{{ allMonthlyProfiles.length }} / {{ totalMonthlyProfilesContactFetched }}</h3>
                        <h3 class="ui-messages-error my-auto">Failed {{ monthlyProfilesContactFetchedFailed.length }}
                        </h3>
                    </div>
                    <p-messages key="profile-contact-error"></p-messages>
                </div>
            </ng-template>
        </div>
    </div>
</div>

<div class="footer-version">Version: {{version}} {{activeFile}}</div>
